module.exports = __webpack_public_path__ + "img/03-3-4提高竞争力.9193b065.svg";